import qc from 'qc'
import iframe from '@ps/bridge/iframe/iframe'

export default {
  find(uuid: string): qc.Node {
    return iframe.nodePool.find(uuid)
  },

  remove(uuid: string): void {
    return iframe.nodePool.remove(uuid)
  }
}
